import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { CompanyAddComponent } from '../company-add/company-add.component';
import { CompanyEditComponent } from '../company-edit/company-edit.component';
import { ConstantsModule } from '../constants/constants.module';
import { ConnectedPageWithTable } from '../root_classes/connected-page-with-table';

@Component({
	selector: 'app-company-list',
	templateUrl: './company-list.component.html',
	styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent extends ConnectedPageWithTable implements OnInit {

	public stateChoice: any[] = [];

  constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
	super(constantsModule, cookieService, httpClient, router, modalService);

	// Creating filter list.
	this.stateChoice = [
		{label: "Active", value:'true'},
		{label: "Désactivée", value:'false'}
	];
  }

	ngOnInit(): void {
		// Preparing the list of columns.
		this.setColumns([
			{field:"name", header:"Nom", sort:"name"},
			{field:"active", header:"Etat", sort:"active"},
		]);

		// Loading data from the server.
		this.loadData("/api/company-list");
	}

  	/* Actions */
	public doActivate(companyId: string): void {
		// Sending activation to the server.
		var newData = {
			"companyid": companyId
		};
		this.put("/api/company-activate", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible d'activer la société.";
				} else {
					this.alertLine.alertSuccessMessage = "Société activée.";
					
					// Replacing the state on the list.
					for(var companyIndex in this.getData()) {
						var company = this.getDataItem(companyIndex);
						if (company._id == companyId) {
							company.active = true;
							break;
						}
					}

					// Fitering again datas.
					this.filterData();
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer la société.";
			}
		);
	}

	public doDeactivate(companyId: string): void {
		// Sending deactivation to the server.
		var newData = {
			"companyid": companyId
		};
		this.put("/api/company-deactivate", newData,
			(response: any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible de désactiver la société.";
				} else {
					this.alertLine.alertSuccessMessage = "Société désactivée.";
					// Replacing the state on the list.
					for(var companyIndex in this.getData()) {
						var company = this.getDataItem(companyIndex);
						if (company._id == companyId) {
							company.active = false;
							break;
						}
					}

					// Filtering again datas.
					this.filterData();
				}
			},
			(err: any) => {
				this.alertLine.alertDangerMessage = "Impossible de désactiver la société.";
			}
		);
	}

	public doRename(companyName: string, companyId: string): void {
		this.runModalDialogWithParameters(CompanyEditComponent, {name: companyName, id: companyId},
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Une société porte déjà le nom demandé. Opération annulée.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver la société à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {

					for(var companyIndex in this.getData()) {
						var company = this.getDataItem(companyIndex);
						if (company._id == reason.id) {
							company.name = reason.name;
							break;
						}
					}

					// Updating the sorting.
					this.filterData();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Société modifiée.";
				}
			}
		);
	}

	/**
	 * Adding a new company.
	 */
	public doAdd(): void {
		this.runModalDialog(CompanyAddComponent,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter la société: La société existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
         			default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {
					// Inserting new item inside the list.
					var newCompany = {
						"_id": reason["_id"],
						"active": reason["active"],
						"name": reason["name"].toUpperCase()
					};

					// Updating for sorting.
					this.datas = [ ...this.datas, newCompany ];

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Société ajoutée.";
				}
			}
		);
	}

	/**
	 * Filter column by its value.
	 * @param event 
	 * @returns 
	 */
	 public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}
}
